<div class="grid">
  <!-- Success state -->
  <ng-container *ngIf="!expired && !failed">
    <h2>{{ "pages.confirmRegistration.title" | translate }}</h2>
    <h5>{{ "pages.confirmRegistration.description" | translate }}</h5>
    <button
      [nbSpinner]="loading"
      nbSpinnerStatus="primary"
      type="submit"
      nbButton
      status="primary"
      (click)="onLogin()"
      [disabled]="loading"
    >
      {{ "buttons.toLogin" | translate }}
    </button>
  </ng-container>

  <!-- Expired token, or the confirmation call failed for any other reason.
       Both land here on purpose: whatever went wrong, the way out is the
       same — ask for a fresh link. -->
  <ng-container *ngIf="expired || failed">
    <h2>
      {{
        (failed
          ? "pages.confirmRegistration.failedTitle"
          : "pages.confirmRegistration.expiredTitle"
        ) | translate
      }}
    </h2>
    <h5>
      {{
        (failed
          ? "pages.confirmRegistration.failedDescription"
          : "pages.confirmRegistration.expiredDescription"
        ) | translate
      }}
    </h5>

    <ng-container *ngIf="!resendSuccess">
      <input
        nbInput
        fullWidth
        type="email"
        [(ngModel)]="resendEmail"
        [placeholder]="'pages.confirmRegistration.emailPlaceholder' | translate"
      />
      <button
        [nbSpinner]="resendLoading"
        nbSpinnerStatus="primary"
        nbButton
        status="primary"
        (click)="onResend()"
        [disabled]="resendLoading || !resendEmail"
      >
        {{ "pages.confirmRegistration.resendButton" | translate }}
      </button>
      <p *ngIf="resendError" class="error-text">{{ resendError }}</p>
    </ng-container>

    <ng-container *ngIf="resendSuccess">
      <nb-icon icon="checkmark-circle-2-outline" status="success"></nb-icon>
      <h5>{{ "pages.confirmRegistration.resendSuccess" | translate }}</h5>
    </ng-container>

    <a class="login-link" routerLink="/auth/login">{{ "buttons.toLogin" | translate }}</a>
  </ng-container>
</div>
